import { SecondaryHeroBackdrop } from "../BrandBackdrop";
import { Skeleton } from "../ui/skeleton";
import { AssetCardSkeleton } from "./AssetCardSkeleton";

export const SecondaryMarketplaceSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-background relative overflow-x-hidden"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading secondary marketplace"
    >
      <div className="container mx-auto px-4 lg:px-8 pb-8 pt-0 relative z-10">
        {/* Hero */}
        <div className="vestn-nav-opening mb-10" style={{ width: '100vw', marginLeft: 'calc(-50vw + 50%)' }}>
          <SecondaryHeroBackdrop />
          <div className="relative z-10 w-full container mx-auto px-4 lg:px-8 flex items-center justify-between py-12 lg:py-16">
            <div className="max-w-2xl">
              <Skeleton className="h-4 w-40 mb-4" />
              <div className="flex items-center gap-3 mb-3">
                <Skeleton className="w-10 h-10 rounded-xl flex-shrink-0" />
                <Skeleton className="h-10 w-64" />
              </div>
              <Skeleton className="h-4 w-full max-w-md mb-2" />
              <Skeleton className="h-4 w-2/3 max-w-xs" />
            </div>
            <div className="hidden lg:flex items-center gap-4 flex-shrink-0">
              <Skeleton className="h-20 w-32 rounded-2xl" />
              <Skeleton className="h-20 w-32 rounded-2xl" />
            </div>
          </div>
        </div>

        {/* Market movers */}
        <div className="mb-8">
          <Skeleton className="h-4 w-44 mb-3" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="flex items-center gap-4 p-4 rounded-2xl bg-card border border-white/[0.07]">
                <div className="flex-1 space-y-1.5">
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-4 w-32" />
                </div>
                <Skeleton className="h-10 w-16 rounded" />
                <div className="text-right space-y-1.5">
                  <Skeleton className="h-4 w-16" />
                  <Skeleton className="h-3 w-12" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="p-6 rounded-2xl bg-card border border-white/[0.07] space-y-3">
              <Skeleton className="h-12 w-12 rounded-xl" />
              <Skeleton className="h-8 w-24" />
              <Skeleton className="h-4 w-20" />
            </div>
          ))}
        </div>

        {/* Toolbar */}
        <div className="flex flex-col lg:flex-row gap-3 mb-10">
          <Skeleton className="h-14 flex-1 rounded-2xl" />
          <Skeleton className="h-14 w-[170px] rounded-2xl" />
          <Skeleton className="h-14 w-[140px] rounded-2xl" />
          <Skeleton className="h-14 w-[140px] rounded-2xl" />
        </div>

        {/* Cards */}
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <AssetCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};
